import React from 'react'
import { Accordion, AccordionSummary, Typography, AccordionDetails, makeStyles, Theme, createStyles } from '@material-ui/core'
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import BasicInfo from './details/BasicInfo'
import DetailsInfo from './details/DetailsInfo'
import VisitsInfo from './details/VisitsInfo'
import { typeBasicInfo, typeDetailsInfo } from '../../../api/helpline/keiyaku';
import { typeVisits } from '../../../api/helpline/qa';

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    heading: {
      fontSize: theme.typography.pxToRem(15),
      fontWeight: theme.typography.fontWeightRegular,
    },
  }),
);

interface Prop {
  basicInfo: typeBasicInfo | undefined,
  mailservice: boolean[] | null,
  detailsInfo: typeDetailsInfo[] | undefined,
  visitsInfo: typeVisits[] | undefined,
  handleClickQAno: (num: string) => void,
}

const ContractEditDetails: React.FC<Prop> = (props) => {
  const classes = useStyles()
  const { basicInfo, mailservice, detailsInfo, visitsInfo, handleClickQAno } = props

  return (
    <React.Fragment>
      <Accordion>
        <AccordionSummary
          expandIcon={<ExpandMoreIcon />}
          aria-controls="basicInfo-content"
          id="basicInfo-header"
        >
          <Typography className={classes.heading}>契約基本情報</Typography>
        </AccordionSummary>
        <AccordionDetails>
          <BasicInfo basicInfo={basicInfo} mailservice={mailservice} />
        </AccordionDetails>
      </Accordion>
      <Accordion>
        <AccordionSummary
          expandIcon={<ExpandMoreIcon />}
          aria-controls="detailsInfo-content"
          id="detailsInfo-header"
        >
          <Typography className={classes.heading}>契約詳細情報</Typography>
        </AccordionSummary>
        <AccordionDetails>
          <DetailsInfo detailsInfo={detailsInfo} />
        </AccordionDetails>
      </Accordion>
      <Accordion disabled={visitsInfo?.length === 0}>
        <AccordionSummary
          expandIcon={<ExpandMoreIcon />}
          aria-controls="detailsInfo-content"
          id="detailsInfo-header"
        >
          <Typography className={classes.heading}>訪問状況</Typography>
        </AccordionSummary>
        <AccordionDetails>
          <VisitsInfo visitsInfo={visitsInfo} handleClickQAno={handleClickQAno} />
        </AccordionDetails>
      </Accordion>
    </React.Fragment>
  )
}

export default ContractEditDetails
